import { MessageOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { clearManualImages } from "./imageResources";
import { HelpChatDrawer } from "./HelpChatDrawer";
import { useManualGeneration, useManualIndex, useManualOwner } from "./manualHooks";
import { useHelpChat, useHelpStatus } from "./useHelpChat";

export function HelpChatButton() {
  const status = useHelpStatus();
  const manual = useManualIndex();
  const chat = useHelpChat(status.data, manual.data?.view);
  const [open, setOpen] = useState(false);
  const [iss, sub] = useManualOwner();
  const generation = useManualGeneration();
  const client = useQueryClient();
  const view = status.data?.view;
  useEffect(() => {
    if (view && manual.data?.view && view !== manual.data.view) {
      const filters = { queryKey: ["manual", iss, sub, manual.data.view] };
      void client.cancelQueries(filters).then(() => client.removeQueries(filters));
      clearManualImages(JSON.stringify([iss, sub, generation]), manual.data.view);
      void client.invalidateQueries({ queryKey: ["manual-index", iss, sub] });
      void client.invalidateQueries({ queryKey: ["help-status", iss, sub] });
    }
  }, [client, generation, iss, manual.data?.view, sub, view]);
  if (status.data?.reason === "feature_disabled") return null;
  return <>
    <Tooltip title={status.data?.message ?? "ヘルプチャット"}>
      <button type="button" className="ux-iconbtn" aria-label="ヘルプチャット" data-testid="help-chat"
        disabled={!status.data?.available} style={{ opacity: status.data?.available ? 1 : .4 }}
        onClick={() => { setOpen(true); void status.refetch(); }}><MessageOutlined /></button>
    </Tooltip>
    <HelpChatDrawer open={open} onClose={() => setOpen(false)} status={status.data} chat={chat} />
  </>;
}
